/*
  STL 2026 — PLP SEO text: Read More / Read Less.

  The short copy (first 150 characters, cut back to a whole word) and the full
  rich text are both rendered by `sections/stl-collection-seo.liquid`, so this
  only toggles between them. Serena, 13 Sep 2026: Read More after a character
  count, which Liquid can do exactly — the earlier line-budget version measured
  in the browser and reflowed once fonts loaded.

  Read Less is rendered after the full copy; it is moved inline into the last
  paragraph so it reads as the end of the text, as Read More does.
*/
(function () {
  if (window.stlCollectionSeoLoaded) return;
  window.stlCollectionSeoLoaded = true;

  function setup(root) {
    var full = root.querySelector('.stl-seo__full');
    var less = root.querySelector('.stl-seo__less');
    if (full && less) {
      var blocks = full.querySelectorAll('p, h1, h2, h3, h4, h5, h6, li');
      var host = blocks.length ? blocks[blocks.length - 1] : null;
      if (host) {
        host.appendChild(document.createTextNode(' '));
        host.appendChild(less);
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.stl-seo__more');
      if (!btn || !root.contains(btn)) return;
      var open = !btn.classList.contains('stl-seo__less');
      root.classList.toggle('is-open', open);
      var next = root.querySelector(open ? '.stl-seo__less' : '.stl-seo__short .stl-seo__more');
      if (next) next.focus({ preventScroll: true });
    });
  }

  function init() {
    document.querySelectorAll('[data-stl-seo]:not([data-stl-seo-ready])').forEach(function (root) {
      root.setAttribute('data-stl-seo-ready', '');
      setup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
